// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindVariants = require("tailwind-variants");

let focusRing = TailwindVariants.tv({
  base: "outline outline-tan-blue-500 outline-0 focus-visible:outline-2",
  variants: {
    isFocusVisible: {
      false: "outline-0",
      true: "outline-2"
    }
  }
});

let Utils = {
  focusRing: focusRing
};

exports.Utils = Utils;
/* focusRing Not a pure module */
